import { BaseQueryFn } from '@reduxjs/toolkit/query'
import { AxiosRequestConfig } from 'axios'
import api from '../../api'

/**
 * Represents a base query function type that handles API requests.
 *
 * @typedef {BaseQueryFn<{url: string, params?: AxiosRequestConfig['params']}, unknown, unknown>} BaseQueryResponse
 */
type BaseQueryResponse = BaseQueryFn<
    {
        url: string
        params?: AxiosRequestConfig['params']
    },
    unknown,
    unknown
>

/**
 * Creates a base query function that performs an asynchronous API request and handles errors.
 *
 * @returns {BaseQueryResponse} An asynchronous function that takes request arguments, performs a request, and returns
 *                             the response or an error.
 */
const baseQuery = (): BaseQueryResponse => async (args: any) => {
    try {
        const response = await api.sentRequest(args.url, args.params)

        if (response.data.errorCode) {
            throw response.data
        }

        return {
            data: response.data.body
        }
    } catch (error) {
        return { error }
    }
}

export default baseQuery
